import React, { useEffect, useState } from "react";
import axios from "axios";
import {
	Area,
	AreaChart,
	CartesianGrid,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import {
	ModalBody,
	Modal,
	ModalContent,
	ModalHeader,
	Button,
} from "@heroui/react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
function OnlineChartModal(props) {
	var color = "success";
	const [data, setData] = useState([]);
	const [yDomain, setYDomain] = useState(["auto", "auto"]);

	useEffect(() => {
		axios.get("/api/live/chart/online?id=" + props.id).then((data) => {
			if (!data.data.data) {
				props.onClose();
				return;
			}
			data.data.data.forEach((item, index) => {
				data.data.data[index].Time = new Date(
					data.data.data[index].Time,
				).toLocaleTimeString();
			});
			setData(data.data.data);
			const fansValues = data.data.data.map((d) => d.Count);
			const minFans = Math.min(...fansValues);
			const maxFans = Math.max(...fansValues);
			const range = maxFans - minFans;

			let padding;
			if (range === 0) {
				padding = minFans * 0.01;
			} else if (range / minFans < 0.01) {
				padding = range * 2;
			} else {
				padding = range * 0.1;
			}

			setYDomain([minFans - padding, maxFans + padding]);
		});
	}, []);
	const CustomTooltip = ({ active, payload, label }) => {
		if (active && payload && payload.length) {
			return (
				<div className=" p-2 border border-gray-200 rounded shadow">
					<p className="text-sm">{`Date: ${label}`}</p>
					<p className="text-sm font-semibold">{`Value: ${payload[0].value}`}</p>
				</div>
			);
		}
		return null;
	};
	return (
		<Modal isOpen={true} size={"3xl"} onClose={props.onClose}>
			<ModalContent className={"w-[1200px] h-[600px]"}>
				<ModalBody>
					<ModalHeader>
						<h2>在线观众</h2>
					</ModalHeader>
					<ResponsiveContainer>
						<AreaChart
							accessibilityLayer
							data={data}
							margin={{
								left: 10,
								right: 10,
								top: 10,
								bottom: 10,
							}}
						>
							<defs>
								<linearGradient
									id="colorGradient"
									x1="0"
									x2="0"
									y1="0"
									y2="1"
								>
									<stop
										offset="10%"
										stopColor={`hsl(var(--heroui-${color}-500))`}
										stopOpacity={0.3}
									/>
									<stop
										offset="100%"
										stopColor={`hsl(var(--heroui-${color}-100))`}
										stopOpacity={0.1}
									/>
								</linearGradient>
							</defs>
							<CartesianGrid
								stroke="hsl(var(--heroui-default-200))"
								strokeDasharray="3 3"
								vertical={false}
							/>
							<XAxis
								axisLine={false}
								dataKey="Time"
								style={{
									fontSize: "var(--heroui-font-size-tiny)",
								}}
								tickLine={false}
								tickMargin={5}
								tickFormatter={(value) => value}
							/>
							<YAxis
								domain={yDomain}
								axisLine={false}
								tickLine={false}
								tickMargin={8}
								tickFormatter={(value) =>
									Math.round(value).toString()
								}
								tickCount={6}
								style={{
									fontSize: "var(--heroui-font-size-tiny)",
								}}
							/>
							<Tooltip content={<CustomTooltip />} />
							<Area
								type="monotone"
								dataKey="Count"
								stroke={`hsl(var(--heroui-${color}))`}
								strokeWidth={2}
								fill="url(#colorGradient)"
								animationDuration={1000}
								animationEasing="ease"
								activeDot={{
									stroke: `hsl(var(--heroui-${color}))`,
									strokeWidth: 2,
									fill: "hsl(var(--heroui-background))",
									r: 5,
								}}
							/>
						</AreaChart>
					</ResponsiveContainer>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

function OnlineChart({ id }) {
	var color = "success";
	const [data, setData] = useState([]);
	const [yDomain, setYDomain] = useState(["auto", "auto"]);

	useEffect(() => {
		axios.get("/api/live/chart/online?id=" + id).then((data) => {
			data.data.data.forEach((item, index) => {
				data.data.data[index].Time = new Date(
					data.data.data[index].Time,
				).toLocaleTimeString();
			});
			setData(data.data.data);
			const fansValues = data.data.data.map((d) => d.Count);
			const minFans = Math.min(...fansValues);
			const maxFans = Math.max(...fansValues);
			const range = maxFans - minFans;
			let padding;
			if (range === 0) {
				padding = Math.max(minFans * 0.01, 1);
			} else if (minFans > 0 && range / minFans < 0.01) {
				padding = range * 2;
			} else {
				padding = range * 0.1;
			}
			const lowerBound = Math.max(0, minFans - padding);
			setYDomain([lowerBound, maxFans + padding]);
		});
	}, []);
	const CustomTooltip = ({ active, payload, label }) => {
		if (active && payload && payload.length) {
			return (
				<div className=" p-2 border border-gray-200 rounded shadow">
					<p className="text-sm">{`Date: ${label}`}</p>
					<p className="text-sm font-semibold">{`Value: ${payload[0].value}`}</p>
				</div>
			);
		}
		return null;
	};

	return (
		<ResponsiveContainer height={400}>
			<AreaChart
				accessibilityLayer
				data={data}
				margin={{
					left: 10,
					right: 10,
					top: 10,
					bottom: 10,
				}}
			>
				<defs>
					<linearGradient
						id="colorGradient"
						x1="0"
						x2="0"
						y1="0"
						y2="1"
					>
						<stop
							offset="10%"
							stopColor={`hsl(var(--heroui-${color}-500))`}
							stopOpacity={0.3}
						/>
						<stop
							offset="100%"
							stopColor={`hsl(var(--heroui-${color}-100))`}
							stopOpacity={0.1}
						/>
					</linearGradient>
				</defs>
				<CartesianGrid
					stroke="hsl(var(--heroui-default-200))"
					strokeDasharray="3 3"
					vertical={false}
				/>
				<XAxis
					axisLine={false}
					dataKey="Time"
					style={{
						fontSize: "var(--heroui-font-size-tiny)",
					}}
					tickLine={false}
					tickMargin={5}
					tickFormatter={(value) => value}
				/>
				<YAxis
					domain={yDomain}
					axisLine={false}
					tickLine={false}
					tickMargin={8}
					tickFormatter={(value) => Math.round(value).toString()}
					tickCount={6}
					style={{
						fontSize: "var(--heroui-font-size-tiny)",
					}}
				/>
				<Tooltip content={<CustomTooltip />} />
				<Area
					type="monotone"
					dataKey="Count"
					stroke={`hsl(var(--heroui-${color}))`}
					strokeWidth={2}
					fill="url(#colorGradient)"
					animationDuration={1000}
					animationEasing="ease"
					activeDot={{
						stroke: `hsl(var(--heroui-${color}))`,
						strokeWidth: 2,
						fill: "hsl(var(--heroui-background))",
						r: 5,
					}}
				/>
			</AreaChart>
		</ResponsiveContainer>
	);
}

export { OnlineChartModal, OnlineChart };
